module.exports = __webpack_public_path__ + "static/media/cu.aa343286.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/cu.svg
// module id = 2070
// module chunks = 0